import { useState, useEffect } from 'react';
import { v4 } from "uuid";
import LoadingSpinner from '../LoadingSpinner'
import serviceMethods from "../../service";
import { useFlowCategories } from '@Hooks/useFlowCategories';
import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';

const FlowBuilderLeftSidebar = ({ currentFlowStages, setCurrentFlowStages, flowDetails, setFlowDetails, setSearchParams, allFlows, handleSubmit, updateDisabled, handleOpenModal, setAllTypeformForms, getMatchingFlow, canWrite }) => {
  const [loading, setLoading] = useState(false)

  const createNewId = v4();

  const handleFlowSelector = (e) => {
    const selectedFlow = allFlows.find((flow) => flow.id === e.target.value)
    if (selectedFlow) {
      setSearchParams({ id: selectedFlow.id })
      getMatchingFlow(selectedFlow.id)
    } else {
      setFlowDetails({
        id: null,
        flowTitle: null
      })
      setCurrentFlowStages([])
      setSearchParams({})
    }
  }

  const handleAddStage = () => {
    const newStage = {
      id: createNewId,
      title: null,
      flowStageTypeId: null,
      dependencyIdentifiers: [],
      conditions: null,
      flowId: flowDetails.id ? flowDetails.id : null,
      nextStageId: null
    };
    setCurrentFlowStages(prevStages => [...prevStages, newStage]);
  };

  const handleTriggerScript = async (script) => {
    const res = await serviceMethods.runScript(script)
    const data = await res.json()
    const forms = JSON.parse(data.forms)
    setLoading(false)
    setAllTypeformForms(forms)
  }

  const {
    data: flowCategories,
    isError,
    error,
  } = useFlowCategories({ searchParams: {} });

  useEffect(() => {
    if (isError && error) {
      toastError(
        error instanceof Error
          ? error.message
          : 'Failed to load Flow Categories',
      );
    }
  }, [isError, error]);

  return (
    <div className="flex flex-col w-[30%] bg-white p-4 shadow-md rounded-l overflow-auto">
      <h2 className="text-lg font-bold mb-4">Flow Builder</h2>
      <div className='flex flex-col gap-6'>
        <div className='flex flex-col'>
          <h3 className="text-sm text-gray-500">Select Flow:</h3>
          <select
            className='border rounded-md p-2'
            value={flowDetails.id || ''}
            onChange={(e) => {
              handleFlowSelector(e)
            }}
          >
            <option value=''>
              Create New Flow
            </option>
            {Array.isArray(allFlows) && allFlows?.map((flow) => (
              <option value={flow.id || ''} key={flow.id}>
                {flow.flowTitle}
              </option>
            ))}
          </select>
        </div>

        <div className='flex flex-col'>
          <h3 className="text-sm text-gray-500">Flow Title:</h3>

          <input
            type="text"
            placeholder="Flow name..."
            className="border px-3 py-2 rounded-md w-full mb-4"
            value={flowDetails?.flowTitle || ''}
            onChange={(e) => {
              setFlowDetails({
                ...flowDetails,
                flowTitle: e.target.value
              })
            }}
          />
        </div>

        <div className='flex flex-col'>
          <h3 className="text-sm text-gray-500">Flow Category:</h3>
          <select
            className="border px-3 py-2 rounded-md w-full"
            id={'category-selector-dropdown'}
            value={flowDetails?.categoryId || ''}
            onChange={(e) => {
              setFlowDetails({
                ...flowDetails,
                categoryId: e.target.value
              })
            }}
          >
            <option value={''} disabled hidden className='opacity-10'>
              --Select Category--
            </option>
            {flowCategories?.data?.map((cat, i) => {
              return (
                <option value={cat.id || ''} key={`cat${i}-${cat.id}`}>
                  {cat.name}
                </option>
              )
            })}
          </select>
        </div>

        <Button
          variant='outline'
          onClick={handleAddStage}
          disabled={!canWrite}
        >
          ➕ Add Stage
        </Button>

        <Button
          variant='outline'
          onClick={() => {
            setLoading(true)
            handleTriggerScript('sync-typeform')
          }}
          disabled={loading || !canWrite}
        >{loading ? <LoadingSpinner /> : 'Sync Typeform'}</Button>
      </div>

      <div className='flex h-full items-end gap-4 mt-6'>
        {!flowDetails?.id ? (
          <Button
            variant='primary'
            onClick={handleSubmit}
            disabled={updateDisabled || !canWrite}
          >
            Submit
          </Button>
        ) : (
          <>
            <Button
              variant='primary'
              onClick={handleSubmit}
              disabled={updateDisabled || !canWrite}
            >
              Update
            </Button>

            <Button
              variant='destructive'
              type='button'
              onClick={() => { handleOpenModal('delete-flow') }}
              disabled={!canWrite}
            >
              Delete
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default FlowBuilderLeftSidebar;